// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__gEM5o","inner":"Form_inner__1bqJh","range":"Form_range__U0sLf","name":"Form_name__M37R9","actions":"Form_actions__3ZZzk"};